import * as React from "react"
import { Form } from "antd"
import { TextInput, Select, DatePicker } from "components-design-system"
import "./ActionItemsWorkflowFields.scss"

const ActionItemsWorkflowFields = ({ actionItemDisabled }) => {
  return (
    <div className="workflow-card workflow-modal-action-items">
      {/* required fields */}
      <div className="workflow-action-item-fields-row">
        {/* name */}
        <Form.Item
          name={["actionitem_data", "title"]}
          label="Action item"
          rules={[{ required: !actionItemDisabled }]}
          className="workflow-action-item-title"
        >
          <TextInput allowClear />
        </Form.Item>

        {/* due data */}
        <Form.Item
          name={["actionitem_data", "due_date"]}
          label="Due Date"
          rules={[{ required: !actionItemDisabled }]}
          className="workflow-action-item-due-date"
        >
          <DatePicker allowClear />
        </Form.Item>

        {/* priority */}
        <Form.Item
          name={["actionitem_data", "priority"]}
          label="Priority"
          rules={[{ required: !actionItemDisabled }]}
          className="workflow-action-item-priority"
        >
          <Select
            options={[
              { value: 0, label: "Low" },
              { value: 1, label: "Medium" },
              { value: 2, label: "High" },
            ]}
            disabled={actionItemDisabled}
          />
        </Form.Item>
      </div>
    </div>
  )
}

export default ActionItemsWorkflowFields
